import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './VisitorCounter.css';

const VisitorCounter = () => {
  const [count, setCount] = useState(100);

  useEffect(() => {
    // Check if visitor count exists in localStorage
    const storedCount = Number.parseInt(localStorage.getItem('visitorCount') || '', 10);

    if (Number.isFinite(storedCount)) {
      // If exists, increment and update
      const newCount = storedCount + 1;
      setCount(newCount);
      localStorage.setItem('visitorCount', newCount.toString());
    } else {
      // If not exists, start from 100
      setCount(100);
      localStorage.setItem('visitorCount', '100');
    }
  }, []);

  return createPortal(
    <div className="visitor-counter">
      <div className="visitor-counter__icon" aria-hidden="true">
        <span className="icon-team"></span>
      </div>
      <div className="visitor-counter__content">
        <span className="visitor-counter__label">Visitors:</span>
        <span className="visitor-counter__number">{count.toLocaleString()}</span>
      </div>
    </div>,
    document.body
  );
};

export default VisitorCounter;

